module.exports = __webpack_public_path__ + "static/media/cl.8949f9e6.svg";